module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "user-block"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.profileImage,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "username"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": _vm.readTooltipTitle
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._l((_vm.images), function(image) {
    return _c('img', {
      staticClass: "img-responsive pad",
      attrs: {
        "src": image,
        "alt": "Photo"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _vm._l((_vm.attachments), function(attachment) {
    return _c('div', {
      staticClass: "attachment-block clearfix"
    }, [_c('img', {
      staticClass: "attachment-img",
      attrs: {
        "src": attachment.image,
        "alt": "Attachment Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "attachment-pushed"
    }, [_c('h4', {
      staticClass: "attachment-heading"
    }, [_c('a', {
      attrs: {
        "href": attachment.url
      }
    }, [_vm._v(_vm._s(attachment.title))])]), _vm._v(" "), _c('div', {
      staticClass: "attachment-text"
    }, [_vm._v("\n            " + _vm._s(attachment.text)), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("more")])])])])
  }), _vm._v(" "), _vm._l((_vm.buttons), function(button) {
    return _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": button.onClick
      }
    }, [_c('i', {
      class: button.theme
    }), _vm._v(" " + _vm._s(button.name))])
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted"
  }, [_vm._v(_vm._s(_vm.likeCount) + " likes - " + _vm._s(_vm.commentCount) + " comments")])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer box-comments"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('va-social-box-comment', {
      attrs: {
        "name": comment.name,
        "profileImage": comment.profileImage,
        "text": comment.text,
        "date": comment.date
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('img', {
    staticClass: "img-responsive img-circle img-sm",
    attrs: {
      "src": _vm.profileImage,
      "alt": "Alt Text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-push"
  }, [_c('input', {
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-647c5465!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VASocialBox.vue
// module id = 523
// module chunks = 1